import GoBackButton from '@/common/components/GoBackButton';
import LogRequestShow from '@/common/components/LogRequestShow';
import useCompany from '@/common/hooks/queries/useCompany';
import useCompanyEquipment from '@/common/hooks/queries/useCompanyEquipment';
import { ChevronsRightIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';

const ChangeHistoryShow = () => {
  const { companyId, id: equipmentId } = useParams();

  const { data: company } = useCompany({ id: companyId || '' });

  const { data: equipment } = useCompanyEquipment({ id: equipmentId || '' });

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-x-4 items-center">
          <GoBackButton fallback={`/companies/${companyId}/equipments/${equipmentId}/changeHistory`} />

          <p className="text-white-400 font-normal">
            {company?.general_information?.fantasy_name}
          </p>

          <ChevronsRightIcon color="#ffffffb3" />

          <h2>
            {equipment?.license_plate || equipment?.official_name || 'Não informado'}
          </h2>
        </div>
      </div>

      <div className="h-[calc(100vh-64px-32px-40px)]">
        <LogRequestShow />
      </div>
    </div>
  );
};

export default ChangeHistoryShow;
